import { render, staticRenderFns } from "./RegionSelectSmall.vue?vue&type=template&id=c91f50b8&scoped=true&lang=html&"
import script from "./RegionSelectSmall.vue?vue&type=script&lang=js&"
export * from "./RegionSelectSmall.vue?vue&type=script&lang=js&"
import style0 from "./RegionSelectSmall.vue?vue&type=style&index=0&id=c91f50b8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91f50b8",
  null
  
)

export default component.exports